/*
  Training-aid recommendation quiz (sections/quiz-native.liquid).

  Everything editable lives in the config objects at the top:
    PILLS        – the ten problems, same labels and slugs as the homepage
                   review filter (sections/home-review-filter.liquid)
    QUIZ_STEPS   – the screens, in order, with the branch rule for each
    PILL_POINTS  – points a chosen problem adds to a product handle
    HCP_SPLIT    – problems whose product depends on handicap
    SCORING      – the legacy per-question points (disabled screens)

  Scoring: every answer adds points to product handles. Answers from the
  branch the golfer chose in question 1 (full swing / short game / putting)
  count double; the full-swing questions everyone answers count half for
  short-game and putting golfers. Highest total = primary recommendation,
  runner-up = "also helps". Ties break on PRIORITY order. ArmAlarm is
  deliberately absent.

  At the email step the answers are written to Klaviyo (client subscribe API
  with quiz_* profile properties and a "Completed Training Aid Quiz" event);
  the phone step adds SMS consent. The last screen redirects to the results
  page with the answers in the query string, which quiz-results reads.
*/
(function () {
  'use strict';

  var PILLS = [
    { label: 'Slices & Hooks', slug: 'slices-hooks' },
    { label: 'Inconsistent Contact', slug: 'inconsistent-contact' },
    { label: 'Distance & Power', slug: 'distance-power' },
    { label: 'Flipping & Casting', slug: 'flipping-casting' },
    { label: 'Missed Short Putts', slug: 'short-putts' },
    { label: 'Three-Putts & Speed', slug: 'three-putts' },
    { label: 'Reading Greens', slug: 'green-reading' },
    { label: 'Alignment & Aim', slug: 'alignment-aim' },
    { label: 'Chipping & Pitching', slug: 'chipping' },
    { label: 'Bunker Play', slug: 'bunkers' }
  ];
  var PILL_LABELS = PILLS.map(function (p) { return p.label; });
  function slugOf(label) {
    for (var i = 0; i < PILLS.length; i++) if (PILLS[i].label === label) return PILLS[i].slug;
    return null;
  }
  var NOTHING_ELSE = 'Nothing else';

  var QUIZ_STEPS = [
    { id: 'problem', type: 'single', title: "What's costing you the most strokes?",
      help: 'Pick the one that hurts the most. You can add more next.',
      options: PILL_LABELS },

    { id: 'also', type: 'multi', title: 'Anything else you want to fix?',
      help: 'Optional. Select all that apply.', exclusive: NOTHING_ELSE, allowEmpty: true,
      options: function (a) {
        return PILL_LABELS.filter(function (l) { return l !== a.problem; }).concat([NOTHING_ELSE]);
      } },

    { id: 'hcp', type: 'single', title: "What's your handicap?",
      options: ['5 or less', '5-15', '15-25', '25+'] },

    { id: 'name', type: 'text', title: "What's your first name?", placeholder: 'First name', autocomplete: 'given-name' },

    { id: 'email', type: 'email', title: 'Where should we send your results?', placeholder: 'you@email.com', autocomplete: 'email' },

    { id: 'sms', type: 'single', title: 'Do you want SMS-only exclusive deals?', help: 'Opt out anytime',
      options: ['Yes', 'No'] },

    { id: 'phone', type: 'phone', title: "Great! What's your phone number?", placeholder: '(555) 555-5555', autocomplete: 'tel',
      show: function (a) { return a.sms === 'Yes'; },
      help: 'I agree to receive recurring automated text messages at the phone number provided. Consent is not a condition to purchase. Message & data rates may apply. Message frequency varies. Reply STOP to unsubscribe.' },

    /* ---- Disabled: the previous area-then-miss flow. Flip `enabled: true`
       to bring a screen back; its scoring is still in SCORING below. ---- */
    { id: 'area', enabled: false, type: 'single', title: 'Which part of your golf game needs the most help?',
      options: ['Full Swing', 'Short Game', 'Putting'] },
    { id: 'goal', enabled: false, type: 'single', title: 'What part of your full swing can we help you improve?',
      show: function (a) { return a.area === 'Full Swing'; },
      options: ['Increasing Distance', 'Accuracy', 'Getting Consistent Contact'] },
    { id: 'sg', enabled: false, type: 'single', title: 'What part of your short game can we help you improve?',
      show: function (a) { return a.area === 'Short Game'; },
      options: ['Chipping/Pitching', 'Bunker Shots'] },
    { id: 'chip', enabled: false, type: 'single', title: 'What happens most commonly on a bad chip or pitch?',
      show: function (a) { return a.sg === 'Chipping/Pitching'; },
      options: ['Chunk', 'Thin', 'I suck at everything'] },
    { id: 'bunker', enabled: false, type: 'single', title: 'What happens most commonly on a bad greenside bunker shot?',
      show: function (a) { return a.sg === 'Bunker Shots'; },
      options: ['Left it in the bunker', 'Skull over the green', "It's all over the place"] },
    { id: 'putt', enabled: false, type: 'single', title: 'What happens most commonly when a putt goes wrong?',
      show: function (a) { return a.area === 'Putting'; },
      options: ['Pull', 'Push', 'No feel for distance', 'Misread', 'Everything goes wrong'] },
    { id: 'faults', enabled: false, type: 'multi', title: 'Do you struggle with any of these in your swing?',
      help: 'Select all that apply', exclusive: 'None of the above',
      show: function (a) { return a.area === 'Full Swing'; },
      options: ['Over the Top', 'Swaying', 'Casting/Flipping Early', 'Shifting Weight/Pressure', 'None of the above'] },
    { id: 'dir', enabled: false, type: 'single', title: 'When the direction of your 7-iron is bad, is the ball most commonly a:',
      options: ['Pull', 'Push', 'Slice', 'Hook', 'Could be any of the above'] },
    { id: 'contact_miss', enabled: false, type: 'single', title: 'When the contact of your 7-iron is bad, is the ball most commonly hit:',
      options: ['Thin', 'Fat', 'Could be either'] },
    { id: 'driver', enabled: false, type: 'single', title: 'How far do you currently hit your driver?',
      options: ['Under 220 yards', '220-250 yards', 'Over 250 yards'] },
    { id: 'freq', enabled: false, type: 'single', title: 'How often do you use golf training aids?',
      options: ['Never', 'Sometimes', 'Frequently'] },
    { id: 'age', enabled: false, type: 'single', title: "What's your age?",
      options: ['Under 35', '35-60', '60+'] }
  ];

  /* Points a chosen problem adds to a product handle. The main problem counts
     in full; each "anything else" pick counts ALSO_WEIGHT of this. Taken from
     which products the homepage reviews under each pill name. */
  var PILL_POINTS = {
    'slices-hooks':         { 'alignment-disc': 6, 'alignment-mirror': 2 },
    'distance-power':       { 'pressure-plate': 6, 'wrist-x': 2 },
    'flipping-casting':     { 'wrist-x': 6, 'pressure-plate': 2 },
    'short-putts':          { 'putting-thing': 6, 'slope-plate': 2 },
    'three-putts':          { 'putting-thing': 6, 'slope-plate': 2, 'green-cards': 1 },
    'green-reading':        { 'slope-plate': 6, 'green-cards': 3 },
    'alignment-aim':        { 'alignment-mirror': 6, 'alignment-disc': 2 },
    'bunkers':              { 'bunker-mate': 6, 'chipping-plate': 2 }
  };
  /* Problems where the reviews name two products: Wrist-X for golfers who can
     already feel their swing, the plate for everyone else. */
  var HCP_SPLIT = {
    'inconsistent-contact': { low: { 'wrist-x': 6, 'pressure-plate': 3 }, high: { 'pressure-plate': 6, 'wrist-x': 3 } },
    'chipping':             { low: { 'wrist-x': 6, 'chipping-plate': 3 }, high: { 'chipping-plate': 6, 'wrist-x': 3 } }
  };
  var LOW_HANDICAP = ['5 or less', '5-15'];
  var ALSO_WEIGHT = 0.4;

  function pillPoints(slug, answers) {
    if (HCP_SPLIT[slug]) return LOW_HANDICAP.indexOf(answers.hcp) !== -1 ? HCP_SPLIT[slug].low : HCP_SPLIT[slug].high;
    return PILL_POINTS[slug] || {};
  }

  /* Points per answer. Keys are Shopify product handles. */
  var SCORING = {
    goal: {
      'Increasing Distance':        { 'pressure-plate': 4, 'wrist-x': 1 },
      'Accuracy':                   { 'alignment-disc': 2, 'alignment-mirror': 2 },
      'Getting Consistent Contact': { 'pressure-plate': 2, 'wrist-x': 2 }
    },
    dir: {
      'Pull':  { 'alignment-disc': 2, 'alignment-mirror': 1 },
      'Push':  { 'alignment-mirror': 2, 'wrist-x': 1 },
      'Slice': { 'alignment-disc': 3, 'alignment-mirror': 1 },
      'Hook':  { 'wrist-x': 2, 'alignment-disc': 1 },
      'Could be any of the above': { 'alignment-mirror': 2 }
    },
    contact_miss: {
      'Thin': { 'wrist-x': 3 },
      'Fat':  { 'pressure-plate': 3 },
      'Could be either': { 'pressure-plate': 2, 'wrist-x': 2 }
    },
    driver: {
      'Under 220 yards': { 'pressure-plate': 1, 'wrist-x': 1 }
    },
    faults: {
      'Over the Top':             { 'alignment-disc': 4, 'alignment-mirror': 1 },
      'Swaying':                  { 'alignment-mirror': 3, 'pressure-plate': 2 },
      'Casting/Flipping Early':   { 'wrist-x': 4 },
      'Shifting Weight/Pressure': { 'pressure-plate': 4 }
    },
    chip: {
      'Chunk': { 'chipping-plate': 4, 'wrist-x': 1 },
      'Thin':  { 'wrist-x': 3, 'chipping-plate': 2 },
      'I suck at everything': { 'chipping-plate': 3, 'wrist-x': 2 }
    },
    bunker: {
      'Left it in the bunker':   { 'bunker-mate': 4, 'wrist-x': 1 },
      'Skull over the green':    { 'bunker-mate': 4, 'chipping-plate': 1 },
      "It's all over the place": { 'bunker-mate': 4 }
    },
    putt: {
      'Pull': { 'putting-thing': 4, 'slope-plate': 1 },
      'Push': { 'putting-thing': 4, 'slope-plate': 1 },
      'No feel for distance': { 'putting-thing': 3, 'slope-plate': 2 },
      'Misread': { 'slope-plate': 4, 'green-cards': 3 },
      'Everything goes wrong': { 'putting-system': 4, 'putting-thing': 2 }
    },
    hcp: {
      '5 or less': { 'wrist-x': 1 },
      '25+': { 'wrist-x': -1 }
    }
  };

  /* Which branch each scored question belongs to; answers in the chosen
     branch count double. */
  var BRANCH = {
    goal: 'Full Swing', dir: 'Full Swing', contact_miss: 'Full Swing', driver: 'Full Swing', faults: 'Full Swing',
    chip: 'Short Game', bunker: 'Short Game',
    putt: 'Putting'
  };

  var PRIORITY = ['putting-thing', 'pressure-plate', 'wrist-x', 'alignment-mirror', 'alignment-disc',
    'chipping-plate', 'bunker-mate', 'slope-plate', 'green-cards', 'putting-system'];

  /* Query-string keys carried to the results page. Email and phone never go
     in the URL. */
  var URL_KEYS = ['name', 'hcp', 'area', 'goal', 'sg', 'chip', 'bunker', 'putt', 'dir', 'contact_miss', 'driver', 'faults', 'freq', 'age'];

  function score(answers) {
    var totals = {};
    Object.keys(SCORING).forEach(function (q) {
      var ans = answers[q];
      if (ans == null) return;
      var list = Array.isArray(ans) ? ans : [ans];
      /* Chosen branch counts double; the full-swing questions everyone
         answers count half for short-game and putting golfers. */
      var mult = 1;
      if (BRANCH[q] && BRANCH[q] === answers.area) mult = 2;
      else if (BRANCH[q] === 'Full Swing' && answers.area !== 'Full Swing') mult = 0.5;
      list.forEach(function (label) {
        var pts = SCORING[q][label];
        if (!pts) return;
        Object.keys(pts).forEach(function (handle) {
          totals[handle] = (totals[handle] || 0) + pts[handle] * mult;
        });
      });
    });
    var problem = slugOf(answers.problem);
    var alsoSlugs = (Array.isArray(answers.also) ? answers.also : []).map(slugOf).filter(function (x) { return x && x !== problem; });
    if (problem) {
      var pp = pillPoints(problem, answers);
      Object.keys(pp).forEach(function (h) { totals[h] = (totals[h] || 0) + pp[h]; });
    }
    alsoSlugs.forEach(function (slug) {
      var ap = pillPoints(slug, answers);
      Object.keys(ap).forEach(function (h) { totals[h] = (totals[h] || 0) + ap[h] * ALSO_WEIGHT; });
    });
    var ranked = PRIORITY.filter(function (h) { return totals[h] > 0; })
      .sort(function (a, b) {
        if (totals[b] !== totals[a]) return totals[b] - totals[a];
        return PRIORITY.indexOf(a) - PRIORITY.indexOf(b);
      });
    if (!ranked.length) ranked = ['putting-thing'];
    return { primary: ranked[0], secondary: ranked[1] || null, totals: totals };
  }

  function toE164(raw) {
    var digits = String(raw || '').replace(/\D/g, '');
    if (digits.length === 10) return '+1' + digits;
    if (digits.length === 11 && digits.charAt(0) === '1') return '+' + digits;
    if (digits.length > 10 && String(raw).trim().charAt(0) === '+') return '+' + digits;
    return null;
  }

  function buildProperties(answers, result) {
    var problemSlug = slugOf(answers.problem);
    var alsoLabels = (Array.isArray(answers.also) ? answers.also : []).filter(function (l) { return l !== NOTHING_ELSE && l !== answers.problem; });
    var props = {
      quiz_name: 'Training Aid Quiz',
      quiz_completed_at: new Date().toISOString(),
      quiz_problem: problemSlug || '',
      quiz_problem_label: answers.problem || '',
      quiz_also: alsoLabels.join(', '),
      quiz_handicap: answers.hcp || '',
      quiz_recommendation: result.primary,
      quiz_recommendation_alt: result.secondary || ''
    };
    /* Legacy screens, only when one of them was answered. */
    var legacy = {
      quiz_area: answers.area, quiz_full_swing_goal: answers.goal, quiz_short_game_part: answers.sg,
      quiz_chip_miss: answers.chip, quiz_bunker_miss: answers.bunker, quiz_putt_miss: answers.putt,
      quiz_iron_direction: answers.dir, quiz_iron_contact: answers.contact_miss, quiz_driver_distance: answers.driver,
      quiz_swing_faults: Array.isArray(answers.faults) ? answers.faults.join(', ') : answers.faults,
      quiz_training_aid_use: answers.freq, quiz_age: answers.age
    };
    Object.keys(legacy).forEach(function (k) { if (legacy[k]) props[k] = legacy[k]; });
    return props;
  }

  function klaviyoSubscribe(cfg, attributes) {
    var body = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: cfg.customSource || 'Training Aid Quiz',
          profile: { data: { type: 'profile', attributes: attributes } }
        }
      }
    };
    if (cfg.listId) body.data.relationships = { list: { data: { type: 'list', id: cfg.listId } } };
    var url = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(cfg.companyId);
    return fetch(url, {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: '2025-07-15' },
      body: JSON.stringify(body)
    }).catch(function () {});
  }

  /* Fired the moment the email step is submitted: every scored answer is
     already in, so the recommendation is final. Doing it here, rather than
     at the redirect, means the write never races the navigation. */
  function sendEmailToKlaviyo(cfg, answers) {
    if (!cfg.companyId || !answers.email) return;
    var result = score(answers);
    var props = buildProperties(answers, result);
    klaviyoSubscribe(cfg, {
      email: answers.email,
      first_name: answers.name || undefined,
      properties: props,
      subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
    });
    try {
      window.klaviyo = window.klaviyo || [];
      window.klaviyo.push(['identify', { $email: answers.email, $first_name: answers.name || '' }]);
      window.klaviyo.push(['track', 'Completed Training Aid Quiz', props]);
    } catch (e) { /* ignore */ }
  }

  /* Fired when the phone step is submitted; a rejected number can never
     cost the email subscription because that request already went. */
  function sendSmsToKlaviyo(cfg, answers) {
    var phone = answers.sms === 'Yes' ? toE164(answers.phone) : null;
    if (!cfg.companyId || !answers.email || !phone) return;
    klaviyoSubscribe(cfg, {
      email: answers.email,
      phone_number: phone,
      subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } }
    });
  }

  function resultsUrl(cfg, answers, result) {
    var qs = [];
    URL_KEYS.forEach(function (k) {
      var v = answers[k];
      if (v == null || v === '') return;
      if (Array.isArray(v)) v = v.join(',');
      qs.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    });
    var problemSlug = slugOf(answers.problem);
    if (problemSlug) qs.push('problem=' + encodeURIComponent(problemSlug));
    var alsoSlugs = (Array.isArray(answers.also) ? answers.also : []).map(slugOf).filter(function (x) { return x && x !== problemSlug; });
    if (alsoSlugs.length) qs.push('also=' + encodeURIComponent(alsoSlugs.join(',')));
    qs.push('rec=' + encodeURIComponent(result.primary));
    if (result.secondary) qs.push('alt=' + encodeURIComponent(result.secondary));
    /* Carry a theme preview through so the flow can be tested end to end. */
    var current = new URLSearchParams(window.location.search);
    if (current.get('preview_theme_id')) qs.push('preview_theme_id=' + encodeURIComponent(current.get('preview_theme_id')));
    var base = cfg.resultsPath || '/pages/quiz-results';
    return base + (base.indexOf('?') === -1 ? '?' : '&') + qs.join('&');
  }

  /* ---------- rendering ---------- */

  function track(action, params) {
    try { if (typeof window.wgTrack === 'function') window.wgTrack(action, params); } catch (e) { /* ignore */ }
  }

  function el(tag, attrs, children) {
    var node = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') node.className = attrs[k];
      else if (k === 'text') node.textContent = attrs[k];
      else if (k === 'html') node.innerHTML = attrs[k];
      else node.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) node.appendChild(c); });
    return node;
  }

  function Quiz(root) {
    this.root = root;
    this.cfg = {
      companyId: root.dataset.klaviyoCompany || '',
      listId: root.dataset.klaviyoList || '',
      customSource: root.dataset.klaviyoSource || '',
      resultsPath: root.dataset.resultsPath || '/pages/quiz-results',
      skipIntro: root.dataset.skipIntro === 'true',
      heading: root.dataset.quizHeading || ''
    };
    this.answers = {};
    this.history = [];
    this.stage = root.querySelector('[data-quiz-stage]');
    this.intro = root.querySelector('[data-quiz-intro]');
    var self = this;
    var start = root.querySelector('[data-quiz-start]');
    if (start && !this.cfg.skipIntro) start.addEventListener('click', function () { self.begin(); });
    else this.begin();
  }

  Quiz.prototype.visibleSteps = function () {
    var a = this.answers;
    return QUIZ_STEPS.filter(function (s) { return s.enabled !== false && (!s.show || s.show(a)); });
  };

  /* Drop answers whose question is no longer on the path (e.g. a chipping
     answer after the golfer went back and switched to Full Swing), so a stale
     answer can neither keep its follow-up question alive nor score. Loops
     because visibility can depend on an answer that was just removed. */
  Quiz.prototype.pruneAnswers = function () {
    var self = this;
    var changed = true;
    while (changed) {
      changed = false;
      var visible = {};
      this.visibleSteps().forEach(function (s) { visible[s.id] = true; });
      QUIZ_STEPS.forEach(function (s) {
        if (!visible[s.id] && self.answers[s.id] != null) { delete self.answers[s.id]; changed = true; }
      });
    }
  };

  Quiz.prototype.begin = function () {
    if (this.intro) this.intro.hidden = true;
    this.root.classList.add('is-running');
    track('quiz_start', { label: this.cfg.skipIntro ? 'direct' : 'intro' });
    this.goTo(QUIZ_STEPS[0].id);
  };

  Quiz.prototype.nextStepId = function (fromId) {
    var steps = this.visibleSteps();
    var idx = -1;
    for (var i = 0; i < steps.length; i++) if (steps[i].id === fromId) { idx = i; break; }
    return steps[idx + 1] ? steps[idx + 1].id : null;
  };

  Quiz.prototype.goTo = function (id) {
    var step = QUIZ_STEPS.filter(function (s) { return s.id === id; })[0];
    if (!step) return;
    this.current = step;
    this.render(step);
    track('quiz_step', { label: step.id, value: this.visibleSteps().indexOf(step) + 1 });
    this.keepInView();
  };

  /* Never move the page on a normal advance; the header stays put and the
     next question appears in place. Only if the golfer has scrolled so the
     question top is above the viewport (or under the sticky header) do we
     bring it back, to just below the header. */
  Quiz.prototype.keepInView = function () {
    try {
      var top = this.root.getBoundingClientRect().top;
      var header = document.querySelector('.shopify-section-header, .section-header, .header-wrapper');
      var headerH = header ? header.getBoundingClientRect().height : 0;
      if (top < headerH) window.scrollBy({ top: top - headerH - 8, behavior: 'smooth' });
    } catch (e) { /* ignore */ }
  };

  Quiz.prototype.advance = function () {
    this.pruneAnswers();
    var next = this.nextStepId(this.current.id);
    this.history.push(this.current.id);
    if (next) this.goTo(next);
    else this.finish();
  };

  Quiz.prototype.back = function () {
    var prev = this.history.pop();
    if (prev) this.goTo(prev);
  };

  Quiz.prototype.render = function (step) {
    var self = this;
    var stage = this.stage;
    stage.innerHTML = '';
    var card = el('div', { class: 'quiz-native__card', 'data-step': step.id });
    var backBtn = el('button', { type: 'button', class: 'quiz-native__back', 'aria-label': 'Back', text: '←' });
    backBtn.addEventListener('click', function () { self.back(); });
    if (!this.history.length) backBtn.disabled = true;
    card.appendChild(backBtn);
    if (this.cfg.skipIntro && this.cfg.heading && !this.history.length) {
      card.appendChild(el('p', { class: 'quiz-native__card-eyebrow', text: this.cfg.heading }));
    }
    card.appendChild(el('h2', { class: 'quiz-native__question', text: step.title }));
    if (step.help && step.type !== 'phone') card.appendChild(el('p', { class: 'quiz-native__help', text: step.help }));

    if (step.type === 'single' || step.type === 'multi') {
      var list = el('div', { class: 'quiz-native__options', role: step.type === 'multi' ? 'group' : 'radiogroup' });
      var options = typeof step.options === 'function' ? step.options(this.answers) : step.options;
      var compact = options.length > 6;
      if (compact) list.classList.add('quiz-native__options--compact');
      var selected = this.answers[step.id];
      var multiSel = Array.isArray(selected) ? selected.filter(function (v) { return options.indexOf(v) !== -1; }) : [];
      options.forEach(function (label, i) {
        var btn = el('button', { type: 'button', class: 'quiz-native__option', 'data-value': label });
        if (!compact) btn.appendChild(el('span', { class: 'quiz-native__key', text: String.fromCharCode(65 + i) }));
        btn.appendChild(el('span', { class: 'quiz-native__label', text: label }));
        var isOn = step.type === 'multi' ? multiSel.indexOf(label) !== -1 : selected === label;
        if (isOn) btn.classList.add('is-selected');
        btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
        btn.addEventListener('click', function () {
          if (step.type === 'single') {
            self.answers[step.id] = label;
            list.querySelectorAll('.quiz-native__option').forEach(function (b) { b.classList.remove('is-selected'); b.setAttribute('aria-pressed', 'false'); });
            btn.classList.add('is-selected'); btn.setAttribute('aria-pressed', 'true');
            setTimeout(function () { self.advance(); }, 120);
          } else {
            if (label === step.exclusive) multiSel = [label];
            else {
              multiSel = multiSel.filter(function (v) { return v !== step.exclusive; });
              var at = multiSel.indexOf(label);
              if (at === -1) multiSel.push(label); else multiSel.splice(at, 1);
            }
            list.querySelectorAll('.quiz-native__option').forEach(function (b) {
              var on = multiSel.indexOf(b.getAttribute('data-value')) !== -1;
              b.classList.toggle('is-selected', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
            });
            nextBtn.disabled = !step.allowEmpty && multiSel.length === 0;
          }
        });
        list.appendChild(btn);
      });
      card.appendChild(list);
      if (step.type === 'multi') {
        var nextBtn = el('button', { type: 'button', class: 'button quiz-native__next', text: step.allowEmpty ? 'Next' : 'Next' });
        nextBtn.disabled = !step.allowEmpty && multiSel.length === 0;
        nextBtn.addEventListener('click', function () { self.answers[step.id] = multiSel.slice(); self.advance(); });
        card.appendChild(nextBtn);
      }
    } else if (step.type === 'statement') {
      var cont = el('button', { type: 'button', class: 'button quiz-native__next', text: step.button || 'Continue' });
      cont.addEventListener('click', function () { self.advance(); });
      card.appendChild(cont);
    } else {
      var form = el('form', { class: 'quiz-native__form', novalidate: 'novalidate' });
      var inputType = step.type === 'email' ? 'email' : step.type === 'phone' ? 'tel' : 'text';
      var input = el('input', { type: inputType, class: 'quiz-native__input', placeholder: step.placeholder || '', autocomplete: step.autocomplete || 'on', 'aria-label': step.title });
      if (this.answers[step.id]) input.value = this.answers[step.id];
      var err = el('p', { class: 'quiz-native__error', role: 'alert', hidden: '' });
      form.appendChild(input);
      form.appendChild(err);
      if (step.type === 'phone' && step.help) form.appendChild(el('p', { class: 'quiz-native__consent', text: step.help }));
      var isLast = !this.nextStepId(step.id);
      var submit = el('button', { type: 'submit', class: 'button quiz-native__next', text: isLast ? 'Get my recommendation' : 'Next' });
      form.appendChild(submit);
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var v = input.value.trim();
        var problem = null;
        if (step.type === 'text' && !v) problem = 'Please enter your first name.';
        if (step.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)) problem = 'Please enter a valid email address.';
        if (step.type === 'phone' && !toE164(v)) problem = 'Please enter a valid phone number.';
        if (problem) { err.textContent = problem; err.hidden = false; input.focus(); return; }
        err.hidden = true;
        self.answers[step.id] = v;
        if (step.id === 'email') { self.pruneAnswers(); sendEmailToKlaviyo(self.cfg, self.answers); }
        if (step.id === 'phone') sendSmsToKlaviyo(self.cfg, self.answers);
        /* The last screen submits the whole quiz. */
        if (!self.nextStepId(step.id)) { self.history.push(step.id); self.finish(); }
        else self.advance();
      });
      card.appendChild(form);
      setTimeout(function () { input.focus(); }, 50);
    }

    stage.appendChild(card);
  };

  Quiz.prototype.finish = function () {
    var self = this;
    if (this.finishing) return;
    this.finishing = true;
    this.pruneAnswers();
    var result = score(this.answers);
    track('quiz_complete', { label: result.primary, value: result.secondary || '' });
    this.stage.innerHTML = '';
    this.stage.appendChild(el('div', { class: 'quiz-native__card quiz-native__card--loading' }, [
      el('div', { class: 'quiz-native__spinner', 'aria-hidden': 'true' }),
      el('p', { class: 'quiz-native__question', text: 'Building your recommendation…' })
    ]));
    var url = resultsUrl(this.cfg, this.answers, result);
    setTimeout(function () { window.location.assign(url); }, 400);
  };

  function init() {
    document.querySelectorAll('[data-quiz-native]').forEach(function (root) {
      if (root.__quiz) return;
      root.__quiz = new Quiz(root);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);

  window.WhyGolfQuiz = { score: score, steps: QUIZ_STEPS, scoring: SCORING, pills: PILLS, pillPoints: PILL_POINTS };
})();
